import { logger } from './logger';

export const waitForGilroyFonts = async (timeout: number = 10000): Promise<boolean> => {
  try {
    await document.fonts.ready;

    const gilroyFonts = [
      document.fonts.load('400 16px "Gilroy"'),
      document.fonts.load('600 16px "Gilroy"'),
      document.fonts.load('700 16px "Gilroy"'),
    ];

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    await Promise.race([
      Promise.all(gilroyFonts).then(() => {
        if (timeoutId) clearTimeout(timeoutId);
      }),
      new Promise(resolve => {
        timeoutId = setTimeout(resolve, timeout);
      }),
    ]);

    const fonts = Array.from(document.fonts);
    const gilroyLoadedFonts = fonts.filter(
      font => font.family.toLowerCase().includes('gilroy') && font.status === 'loaded',
    );

    return gilroyLoadedFonts.length > 0;
  } catch (error) {
    logger.error(`Font loading error: ${error}`);

    return false;
  }
};
